import { useState } from 'react';
import clsx from 'clsx';
import { Icon } from '../../../layout/Icon.jsx';
import { PlatformModal, Field } from './PlatformModal.jsx';

const PRESETS = {
  reject: {
    title: 'رفض طلب الشركة',
    label: 'سبب الرفض',
    hint: 'يُحفظ السبب في سجل الشركة.',
    confirm: 'رفض الطلب',
    tone: { background: '#FEE2E2', color: '#B91C1C' },
    note: 'لن تُهيّأ قاعدة بيانات لهذه الشركة ولن يتمكّن موظفوها من الدخول.'
  },
  suspend: {
    title: 'إيقاف الشركة',
    label: 'سبب الإيقاف',
    hint: 'يُحفظ السبب في سجل الشركة ويظهر في التفاصيل.',
    confirm: 'إيقاف الشركة',
    tone: { background: '#FFF7ED', color: '#9A3412' },
    note: 'سيتوقّف دخول جميع مستخدمي الشركة فوراً، وتبقى بياناتها كما هي. يمكن الاستئناف لاحقاً.'
  }
};

export function ReasonModal({ kind, company, pending, onClose, onConfirm }) {
  const preset = PRESETS[kind] || PRESETS.reject;
  const [reason, setReason] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const error = !reason.trim() ? 'السبب مطلوب' : reason.trim().length < 3 ? 'السبب قصير جداً' : null;

  function submit() {
    setSubmitted(true);
    if (error || pending) return;
    onConfirm(reason.trim());
  }

  return (
    <PlatformModal
      title={preset.title}
      sub={company ? company.name + ' • ' + company.slug : undefined}
      onClose={onClose}
      footer={(
        <>
          <button type="button" className="btn flex-1 justify-center" onClick={onClose}>إلغاء</button>
          <button
            type="button"
            className="btn btn-danger flex-1 justify-center"
            onClick={submit}
            disabled={pending}
          >
            <Icon name="check" size={14} /> {pending ? 'جاري التنفيذ...' : preset.confirm}
          </button>
        </>
      )}
    >
      <div className="rounded-[10px] p-2.5 text-[12.5px]" style={preset.tone}>
        {preset.note}
      </div>
      <Field label={preset.label} required hint={preset.hint} error={submitted ? error : undefined}>
        <textarea
          className={clsx('input', submitted && error && 'border-red')}
          rows={3}
          autoFocus
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="اكتب السبب…"
        />
      </Field>
    </PlatformModal>
  );
}
